import { getConfig, getLocale } from "@jti/fe-common";

import { getIsEvo, getUser } from "../../../utils";

import type { CasPurposesApiContract } from "./CasPurposesApi.types";
import { CasPurposesApiEvo } from "./CasPurposesApiEvo";
import { CasPurposesApiLegacy } from "./CasPurposesApiLegacy";

export class CasPurposesApi {
  static init(): CasPurposesApiContract {
    const user = getUser();
    const config = getConfig();
    const locale = getLocale();

    if (config.USE_EVO_ONLY) {
      return CasPurposesApiEvo.init();
    }
    if (getIsEvo(config.CAS_URL)) {
      return CasPurposesApiEvo.init();
    }
    return new CasPurposesApiLegacy(
      config.CAS_URL,
      config.CAS_X_DES_AK_TENANT_TOKEN,
      user.ciam_token,
      user.uuid || "",
      locale
    );
  }
}
